enum TestIdContext {
  // ── Dominio (objetos con ID único) ───────────────────
  OCCUPATION = 'occupation',
  SKILL = 'skill',
  COURSE = 'course',
  JOB = 'job',
  SKILLS_KANBAN = 'skills',
  // ── Vistas Learner ────────────────────────────────────
  HOME = 'home',
  LEARNING_PATH = 'learning_path',
  PROFILE = 'profile',
  NAVIGATION = 'navigation',
  EXPLORE = 'explore',
  SAVED_COURSES = 'saved_courses',
  LEARNING_RESOURCE_ROI = 'learning_resource_roi',
  AUTH = 'auth',
  RESUME_EXPERIENCE = 'resume_experience',
  // ── Componentes genéricos reutilizables ───────────────
  MODAL = 'modal',
  FILTER = 'filter',
  SIDEBAR = 'sidebar',
  NOTIFICATION = 'notification',
  BOOKMARK_AUTOCOMPLETE = 'bookmark_autocomplete',
}

export default TestIdContext;
